import React from 'react';
import { EventBus } from '@/shared/utils';
import { CatalogEvents } from '../events';

interface CatalogAppWrapperProps {
  children: React.ReactNode;
  eventBus?: EventBus<CatalogEvents>;
}

/**
 * Application wrapper that provides context sharing for the catalog module.
 * No longer needed to provide UserStatusProvider as it's now at the app level.
 */
export const CatalogAppWrapper: React.FC<CatalogAppWrapperProps> = ({ children, eventBus }) => {
  return <>{children}</>;
};
